import React, { useEffect } from "react";
import Wrapper from "../components/Wrapper";
import { useNavigate } from "react-router-dom";
import { useLang } from "../context/LanguageContext";
import { translations } from "../langauge";

const Success = () => {
  const { lang } = useLang();
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/");
    }, 5000);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <Wrapper>
      <div className="row">
        <div className="col-lg-3 col-md-4 col-4 rightSideDivParent">
          <div
            className="rightSideDiv"
          >
            <div className="navbarDiv">
              <ul>
                <li>
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/");
                    }}
                    style={{
                      textAlign: "left",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <img
                      alt="go back"
                      src="./images/left-arrow.png"
                      style={{
                        marginRight: lang === "en" ? "15px" : 0,
                        marginLeft: lang === "ar" ? "15px" : 0,
                        height: "20px",
                        width: "auto",
                        transform: lang === "ar" ? "rotate(180deg)" : undefined,
                      }}
                    />
                    {translations[lang].go_back}
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    onClick={(e) => e.preventDefault()}
                    className="active"
                    style={{ textAlign: lang === "ar" ? "right" : "left" }}
                  >
                    {translations[lang].success_nav}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="col-lg-9 col-md-8 col-8 contentDivParent">
          <div className="contentDiv">
            <div
              className="successContainer"
              style={{ textAlign: lang === "ar" ? "right" : "left" }}
            >
              <div className="successIcon">
                <svg
                  width="80"
                  height="80"
                  viewBox="0 0 80 80"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="40"
                    cy="40"
                    r="40"
                    fill="#1db954"
                    opacity="0.1"
                  />
                  <path
                    d="M40 20C28.9543 20 20 28.9543 20 40C20 51.0457 28.9543 60 40 60C51.0457 60 60 51.0457 60 40C60 28.9543 51.0457 20 40 20ZM35 50L25 40L27.82 37.18L35 44.34L52.18 27.18L55 30L35 50Z"
                    fill="#1db954"
                  />
                </svg>
              </div>
              <h1 className="successHeading">
                {translations[lang].success_heading}
              </h1>
              <p className="successMessage">
                {translations[lang].success_message}
              </p>
              <p className="successRedirect">
                {translations[lang].success_redirect}
              </p>
              <div className="successProgressBar">
                <div className="successProgressFill" />
              </div>
              <button
                type="button"
                className="successButton"
                onClick={() => navigate("/")}
              >
                {translations[lang].success_button}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="mobileBottomMainDiv">
        <p>{translations[lang].success_nav}</p>
      </div>
    </Wrapper>
  );
};

export default Success;
